import { HTTPStatusCode } from "@libs/api/types";
import {
  ListEligibilityResultsFilterType,
  SyncEligibilityResultsType,
} from "@/domain/eligibilityResults";
import { sendSentryError } from "@/services/sentry";
import { tsRestClient } from "@/services/ts-rest";

export const EligibilityResultsApi = {
  syncEligibilityResults: async ({
    householdId,
    body,
  }: {
    householdId: string;
    body: SyncEligibilityResultsType;
  }) => {
    const res = await tsRestClient().eligibilityResults.syncEligibilityResults({
      params: { householdId },
      body,
    });

    if (res.status === HTTPStatusCode.OK) {
      return res.body;
    }

    sendSentryError({
      error: res.body,
      message:
        "Unexpected response in EligibilityResultsApi.syncEligibilityResults",
      shouldThrowError: true,
    });
  },
  listEligibilityResults: async (filters: ListEligibilityResultsFilterType) => {
    const res = await tsRestClient().eligibilityResults.listEligibilityResults({
      query: filters,
    });

    if (res.status === HTTPStatusCode.OK) {
      return res.body;
    }

    sendSentryError({
      error: res.body,
      message: "Failed to list eligibility results",
    });
  },
};
